/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Resume_Perf_TitleInputs */

const en_analytics_resume_perf_title = /** @type {(inputs: Analytics_Resume_Perf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume Performance`)
};

const de_analytics_resume_perf_title = /** @type {(inputs: Analytics_Resume_Perf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf-Leistung`)
};

const fr_analytics_resume_perf_title = /** @type {(inputs: Analytics_Resume_Perf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Performance des CV`)
};

const es_analytics_resume_perf_title = /** @type {(inputs: Analytics_Resume_Perf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendimiento del currículum`)
};

const it_analytics_resume_perf_title = /** @type {(inputs: Analytics_Resume_Perf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestazioni del curriculum`)
};

const nl_analytics_resume_perf_title = /** @type {(inputs: Analytics_Resume_Perf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-prestaties`)
};

const pl_analytics_resume_perf_title = /** @type {(inputs: Analytics_Resume_Perf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skuteczność CV`)
};

const fi_analytics_resume_perf_title = /** @type {(inputs: Analytics_Resume_Perf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansioluettelon suorituskyky`)
};

const da_analytics_resume_perf_title = /** @type {(inputs: Analytics_Resume_Perf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-performance`)
};

const sv_analytics_resume_perf_title = /** @type {(inputs: Analytics_Resume_Perf_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CV-prestanda`)
};

/**
* | output |
* | --- |
* | "Resume Performance" |
*
* @param {Analytics_Resume_Perf_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_resume_perf_title = /** @type {((inputs?: Analytics_Resume_Perf_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Resume_Perf_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_resume_perf_title(inputs)
	if (locale === "fr") return fr_analytics_resume_perf_title(inputs)
	if (locale === "es") return es_analytics_resume_perf_title(inputs)
	if (locale === "it") return it_analytics_resume_perf_title(inputs)
	if (locale === "nl") return nl_analytics_resume_perf_title(inputs)
	if (locale === "pl") return pl_analytics_resume_perf_title(inputs)
	if (locale === "fi") return fi_analytics_resume_perf_title(inputs)
	if (locale === "da") return da_analytics_resume_perf_title(inputs)
	if (locale === "sv") return sv_analytics_resume_perf_title(inputs)
	return en_analytics_resume_perf_title(inputs)
});